var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('judge-link',{attrs:{"listLayout":_vm.listLayout}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }